"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var commonStyles_1 = require("../commonStyles");
exports.Text = styled_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  font-weight: ", ";\n  font-size: ", ";\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"], ["\n  ", ";\n  font-weight: ", ";\n  font-size: ", ";\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), commonStyles_1.commonStyles, function (p) { return p.theme.font.weight[p.weight]; }, function (p) { return p.theme.font.sizes.mobile.paragraph[p.size]; }, function (p) { return p.theme.breakpoints.md; }, function (p) { return p.theme.font.sizes.desktop.paragraph[p.size]; });
var templateObject_1;
